/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BarChartBig = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 3v18h18" }],
    ["rect", { width: "4", height: "7", x: "7", y: "10", rx: "1" }],
    ["rect", { width: "4", height: "12", x: "15", y: "5", rx: "1" }]
  ]
];

export { BarChartBig as default };
//# sourceMappingURL=bar-chart-big.js.map
